<template>
	<div class="box">
		<div>
			<div class="numDoctor">
				<div class="text2">
					<p>昨日申请专家审阅次数</p>
					<p>0</p>
				</div>
				<div class="text2">
					<p>昨日案例分享次数</p>
					<p>0</p>
				</div>
				<div class="text2">
					<p>累计专家审阅次数</p>
					<p>0</p>
				</div>
				<div class="text2">
					<p>累计案例分享次数</p>
					<p>0</p>
				</div>
			</div>
			<div class="chartsDoc">
				<div class="chartsDocheader">
					<div>
						<el-date-picker
						    v-model="value1"
						    type="daterange"
						    range-separator="至"
						    start-placeholder="开始月份"
						    end-placeholder="结束月份">
						    </el-date-picker>
					</div>
					<div class="datebtn">
						<div>近7日</div>
						<div class="active">仅30日</div>
					</div>
				</div>
				<div class="chartsDoccontent">
					<div>
						<fwechart :type="1" :options1="options1" :name="name1" ></fwechart>
					</div>
					<div>
						<!--<fxalEchart :type="2" :options2="options2"  :name="name1" ></fxalEchart>-->
						<!--<zxEchart :type="2" :options="options2"></zxEchart>-->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {user_count} from '../components/http/api.js'
	import fxalEchart from '../component/fxalEcharts.vue'
	import fwechart from '../component/fwEcharts.vue'
	export default{
		components:{
			fxalEchart,
			fwechart
		},
		data(){
			return{
				value1:1,
				options1:[{
					id:'1',
					name:'审阅与分享',
				}],
				options2:[{
					id:1,
					name:'分享案例最多Top10作者',
				},{
					id:2,
					name:'案例查看最多Top10作者',
				}],
				hzNum:'',
				name1:'审阅与分享',
				name2:'审阅与分享统计',
				
			}
		},
		beforeMount() {
			this.user_countFn();
		},
		methods:{
			user_countFn(){
				user_count().then(res=>{
					for(var i=0;i<res.list.length;i++){
					}
				})
			},
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: 100%;
	}
	.box>div{
		height: 364px;
		width: 100%;
		display: flex;
		justify-content: space-between;
		/*background: #FFFFFF;*/
	}
	
	.box>div:nth-child(1){
		margin-bottom: 7px;
	}
	.numDoctor{
		width: 212px;
		height: 344px;
		padding:10px 20px;
		border-radius:3px;
		/*border-right: 3px solid rgba(198,198,198,1);*/
		background: #FFFFFF;
	}
	.text1,.text2{
		margin-bottom: 30px;
	}
	.text1>p:nth-child(1){
		font-size:15px;
		font-weight:400;
		color:rgba(74,74,74,1);
		line-height:23px;
	}
	.text1>p:nth-child(2){
		font-size:30px;
		font-weight:600;
		color:rgba(74,74,74,1);
		margin-top: 8px;
		line-height:23px;
	}
	.text2>p:nth-child(1){
		font-size:15px;
		font-weight:400;
		color:rgba(74,74,74,1);
		line-height:23px;
	}
	.text2>p:nth-child(2){
		margin-top: 8px;
		font-size:30px;
		font-weight:600;
		color:rgba(29,181,255,1);
		line-height:23px;
	}
	.chartsDoc{
		width:1035px;
		height:344px;
		padding: 10px 20px;
		background:rgba(255,255,255,1);
		border-radius:3px;
		
	}
	.chartsDocheader{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.chartsDocheader>div:nth-child(1){
		width: 400px;
	}
	.chartsDocheader>div:nth-child(1)>div{
		width: 400px;
	}
	.datebtn>div:hover{
		border:1px solid yellow;
		
	}
	.datebtn{
		display: flex;
	}
	.datebtn>div{
		margin-right: 13px;
		cursor: pointer;
		width:93px;
		height:42px;
		background:rgba(234,234,234,1);
		border-radius:24px;
		border:1px solid rgba(221,227,232,1);
		font-size:19px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(155,155,155,1);
		line-height:24px;
		display: flex;justify-content: center;
		align-items: center;
	}
	.datebtn>div.active{
		font-size:19px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(255,255,255,1);
		line-height:24px;
		background:rgba(29,181,255,1);
	}
	.chartsDoccontent{
		display: flex;
		justify-content: space-between;
	}
	.chartsDoccontent>div{
		width:497px;
		height: 290px;
		margin-top: 10px;
		/*background: #CCCCCC;*/
	}
	
</style>


// WEBPACK FOOTER //
// src/component/fxEcharts.vue